// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3HqiZ","approved":"Status_approved__2QApT","rejected":"Status_rejected__1ZvhP","expired":"Status_expired__IcQMP","label":"Status_label__2MQda"};